import React from "react"
import GatsbyLink from "gatsby-link"

import { isExternal } from "../utils/url"

export interface LinkProps {
  url: string
  openInNewTab?: boolean
}

const Link: React.FC<LinkProps> = props => {
  const targetProps = props.openInNewTab
    ? {
        target: "_blank",
        rel: "noreferrer",
      }
    : null

  return isExternal(props.url) ? (
    <a className="c-link" href={props.url} {...targetProps}>
      {props.children}
    </a>
  ) : (
    <GatsbyLink className="c-link" to={props.url}>
      {props.children}
    </GatsbyLink>
  )
}

export default Link
